import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';

import { Button, Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';

import { isSigningCompleteModalOpenState } from '../../../../atoms';
import { Lease } from '../../../models';

export function SigningCompleteModal() {
  const history = useHistory();

  const [isSigningCompleteModalOpen, setIsSigningCompleteModalOpen] = useRecoilState(isSigningCompleteModalOpenState);

  function onGoToYourDashboardClick(): void {
    setIsSigningCompleteModalOpen(false);
    history.push(Lease.getDashboardPath());
  }

  function onSigningCompleteModalClose(): void {
    setIsSigningCompleteModalOpen(false);
  }

  return (
    <Modal
      size={{ base: 'fullScreen', md: 'xs' }}
      open={isSigningCompleteModalOpen}
      onOpenChange={(open) => {
        if (!open) {
          onSigningCompleteModalClose();
        }
      }}
      header={<Heading level={1}>Signing complete</Heading>}
      body={
        <>
          <Icon size="lg" role="img" css={{ marginBottom: 'tight', color: 'icon.feedback.success.strong' }}>
            <IconCheckmarkCircleFilled />
          </Icon>
          <Heading level={2} css={{ textStyle: 'responsive.heading-xs', marginBottom: 'tight' }}>
            You’ve finished signing
          </Heading>
          <Paragraph>
            You’re one step closer renewing your lease agreement! We’ll notify you once everyone signs so you can view
            your signed agreement.
          </Paragraph>
        </>
      }
      footer={
        <Button onClick={onGoToYourDashboardClick} tone="brand" emphasis="filled">
          Go to your dashboard
        </Button>
      }
    />
  );
}
